<template>
  <fragment>
    <c-generic-section top-divider>
      <div class="container-xs">
        <h2 class="mt-0">Hiya, I'm Dima from 🇨🇦</h2>
        <p>Partnering with me on an MVP (Minimum Viable Product) for your client's B2B software means benefitting from over a decade of software development and technical project management experience.</p>
        <h4>Reliable, Rapid Dev with no BS</h4>
        <p>You can find cheap tech guys all over the world, but how much miscommunication are you and your clients willing to put up with?</p>
        <p>Working with a native English-speaking Canadian means:</p>
        <ul>
          <li>
            Yes means
            <em>YES</em>, No means
            <em>no</em>, March 2 at 10am means
            <em>March 2 at 10am</em>.
          </li>
          <li>When your client asks for the impossible, I tell you so up front, and make recommendations for options that are more realistic.</li>
          <li>If I'm coming down with the flu or about to head to a wedding, I'll ping you well in advance of being out of commission.</li>
          <li>
            My
            <router-link to="/guarantee">100% money-back guarantee</router-link>&nbsp;is actually a thing.
          </li>
        </ul>
        <p>This stuff seems obvious, but if you've ever worked on a complex software project with remote people, you know how important it is to communicate clearly and proactively.</p>
      </div>
    </c-generic-section>

    <c-cta split />
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
// import sections
import CGenericSection from "@/components/sections/GenericSection.vue";
import CCta from "@/components/sections/Cta.vue";

export default {
  name: "Secondary",
  components: {
    CGenericSection,
    CCta
  },
  data() {
    return {};
  },
  created() {
    this.$emit("update:layout", CLayout);
  }
};
</script>
